import MainLayout from "../components/CommonComponents/MainLayout";
import CustomerDetailsTab from "./CustomerDetailsTab";

export default function CustomerDetailsPage() {
    return (
        <MainLayout>
            <div className="pt-6">
                <CustomerDetailsTab />
            </div>
        </MainLayout>
    );
}